module.exports = __webpack_public_path__ + "media/site/images/products/actionplan-screen@2x-157dbf6033483629b450f4bd224f4124.png";